import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { PersistentInvitePeopleButton } from '@confluence/persistent-invite-button';

import { NAV_COLLAPSE_BREAKPOINT_PX } from '../layoutConstants';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const PersistentInvitePeopleButtonLayout = styled.div<{
	rightSidebarCompensation: number;
}>`
	margin-top: auto;
	.persistent-invite-button-container {
		margin-bottom: ${token('space.400', '32px')};
	}
	.persistent-invite-icon-button {
		display: none;
		padding: ${token('space.050', '4px')};
		width: 100%;
	}
	.persistent-invite-button {
		display: block;
		padding: 0px;
	}
	@media (max-width: ${({ rightSidebarCompensation }) =>
			NAV_COLLAPSE_BREAKPOINT_PX + rightSidebarCompensation}px) {
		.persistent-invite-icon-button {
			display: block;
		}
		.persistent-invite-button {
			display: none;
		}
	}
`;

export function PersistentInvitePeopleButtonContainer({
	rightSidebarCompensation,
}: {
	rightSidebarCompensation: number;
}) {
	return (
		<PersistentInvitePeopleButtonLayout rightSidebarCompensation={rightSidebarCompensation}>
			<PersistentInvitePeopleButton source="homeScreen" hasIconButton />
		</PersistentInvitePeopleButtonLayout>
	);
}
